import { render, staticRenderFns } from "./ClassHeaderCard.vue?vue&type=template&id=3aef89bc"
import script from "./ClassHeaderCard.vue?vue&type=script&lang=js"
export * from "./ClassHeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports